import { StepData } from '@ntv360/component-pantry';
import { Tab } from '@shared';

/**
 * Add content stepper steps
 */
export const ADD_CONTENT_STEPS: StepData[] = [
    {
        id: '1',
        label: 'Select Assets',
    },
    {
        id: '2',
        label: 'Preview',
    },
    {
        id: '3',
        label: 'Settings',
    },
];

/** Single playlist add content select asset step tabs */
export const ADD_CONTENT_SELECT_ASSETS_TAB: { id: number; label: string; iconKey: string }[] = [
    {
        id: 0,
        label: 'Assigned to Dealer',
        iconKey: 'paper-plane',
    },
    {
        id: 1,
        label: 'Floating Contents',
        iconKey: 'paper-plane',
    },
    {
        id: 2,
        label: 'Channels',
        iconKey: 'user',
    },
];

/** Single playlist add content settings step tabs */
export const ADD_CONTENT_SETTINGS_TAB: { id: number; label: string; iconKey: string }[] = [
    {
        id: 0,
        label: 'Basics',
        iconKey: 'settings',
    },
    {
        id: 1,
        label: 'Play Where',
        iconKey: 'paper-plane',
    },
    {
        id: 2,
        label: 'Content Schedule',
        iconKey: 'clock',
    },
];

/** Single playlist add content setting step sub-tabs */
export const ADD_CONTENT_SETTINGS_SUB_TAB: Tab[] = [
    {
        id: '0',
        label: 'Default Play',
        iconKey: 'settings',
    },
    {
        id: '1',
        label: 'Custom Schedule',
        iconKey: 'paper-plane',
    },
    {
        id: '2',
        label: 'Do Not Play',
        iconKey: 'clock',
    },
];
